import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
const API_URL = process.env.REACT_APP_API_URL;
const BankSettings = () => {
    const { t } = useTranslation();
    const { token } = useAuth();
    
    // DÜZELTME: isLoading, error ve message state'lerini ekledik.
    const [formData, setFormData] = useState({ accountHolder: '', bankName: '', iban: '' });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    // DÜZELTME: useEffect'in içi dolduruldu.
    useEffect(() => {
        const fetchPaymentDetails = async () => {
            if (!token) { setLoading(false); return; }
            try {
                setLoading(true); setError('');
                const response = await fetch(`${API_URL}/api/dashboard/profile`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                if (!response.ok) throw new Error(t('error_fetch_profile'));
                const data = await response.json();
                
                // Gelen payment_details verisi string (JSON) ise, onu objeye çevir.
                if (data.payment_details) {
                    setFormData(JSON.parse(data.payment_details));
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        fetchPaymentDetails();
    }, [token, t]);

    const handleChange = (e) => {
        setFormData(p => ({ ...p, [e.target.name]: e.target.value }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage(''); setError('');
        setIsSubmitting(true);
        try {
            const response = await fetch(`${API_URL}/api/dashboard/profile/payment-details`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify(formData)
            });
            const data = await response.json();
            if (!response.ok) {
                throw new Error(t(data.messageKey) || t('error_payment_update_failed', 'Ödeme bilgileri güncellenemedi.'));
            }
            setMessage(t('success_payment_details_updated'));
        } catch (err) {
            setError(err.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (loading) return <p><i className="fas fa-spinner fa-spin"></i> {t('loading', 'Yükleniyor...')}</p>;

    return (
        <div className="profile-form-container">
            <h2>{t('bank_accounts')}</h2>
            <form onSubmit={handleSubmit}>
                <div className="form-group-auth floating-label">
                    <input id="accountHolder" name="accountHolder" type="text" value={formData.accountHolder || ''} onChange={handleChange} required placeholder=" " />
                    <label htmlFor="accountHolder">{t('account_holder_name')}</label>
                </div>
                <div className="form-group-auth floating-label">
                    <input id="bankName" name="bankName" type="text" value={formData.bankName || ''} onChange={handleChange} required placeholder=" " />
                    <label htmlFor="bankName">{t('bank_name')}</label>
                </div>
                <div className="form-group-auth floating-label">
                    <input id="iban" name="iban" type="text" value={formData.iban || ''} onChange={handleChange} required placeholder=" " />
                    <label htmlFor="iban">IBAN</label>
                </div>

                {message && <p className="auth-success">{message}</p>}
                {error && <p className="auth-error">{error}</p>}
                
                <button type="submit" className="cta-button" disabled={isSubmitting}>
                    {isSubmitting ? t('saving', 'Kaydediliyor...') : t('save_changes')}
                </button>
            </form>
        </div>
    );
};

export default BankSettings;